import React, { useState, useEffect } from "react";
import api from "../../../../../../api";
import { Checkbox } from 'semantic-ui-react';
import ConfirmDialog from "../../../../../Modal/ConfirmDialog";
import Modal from "../../../../ChatSetup/components/Modal";
import faqclasses from "./FAQs.module.css";
import DiffModal from "./DiffModal";
export default function FAQs(props) {
  const [loading, setLoading] = useState(false);
  const [addQuestionHTML, addQuestionProcess] = useState([]);
  const [applyError, setApplyError] = useState({ message: "", type: "" });
  const [faqError, setfaqError] = useState(false);
  const [applyModalDetail, setApplyModalDetail] = useState({
    modalDisp: false,
    title: props.botType === "Voice_Turbo"
      ? "Apply this FAQs context to other assistants."
      : "Apply this FAQs context to other context branch.",
  });
  const [modalDetail, modalDetailSet] = useState({ modalDisp: false, title: "Add an additional question for FAQs" });
  const [inputQuestion, setInputQuestion] = useState("");
  const [availableAssistants, setAvailableAssistants] = useState([]);
  const [selectedAssistantsPerBranch, setSelectedAssistantsPerBranch] = useState({});
  const [FaqDiffModel, setFaqDiffModel] = useState(false);
  const [oldAdditionalFaqContext, setoldAdditionalFaqContext] = useState("");
  const [newAdditionalFaqContext, setnewAdditionalFaqContext] = useState("");

  const [promptInput, setPromptInput] = useState("");


  useEffect(() => {
    addQuestionProcess(props.faqdata);
  }, [props.faqdata]);

 const handleConfirm = (finalPrompt) => {
  props.setValue(finalPrompt, "AdditonalFaqContext");
  setPromptInput("");
  setFaqDiffModel(false);
};
  useEffect(() => {
    if (props.branch_id) {
      setSelectedAssistantsPerBranch((prev) => {
        const existing = prev[props.branch_id] || {};
        const updated = {
          ...prev,
          [props.branch_id]: {
            ...existing,
            [props.branch_id]: true,
          },
        };

        if (props.onSelectionChange) {
           props.onSelectionChange(updated);
        }
        return updated;
      });
    }
  }, [props.branch_id]);

  // Example inside child
  const toggleAssistantSelection = (branchId) => {
    setSelectedAssistantsPerBranch((prev) => {
      const current = prev[props.branch_id] || {};
      const newBranchSelection = {
        ...current,
        [branchId]: !current[branchId],
      };

      const updated = {
        ...prev,
        [props.branch_id]: newBranchSelection,
      };

      if (props.onAssistantsChange && typeof props.onAssistantsChange === "function") {
        props.onAssistantsChange(updated);
      }
      return updated;
    });
  };

  const showUnsavedMessage = React.useMemo(() => {
    const selections = selectedAssistantsPerBranch[props.branch_id] || {};
    const selectedCount = Object.values(selections).filter(Boolean).length;
    return selectedCount > 1;
  }, [selectedAssistantsPerBranch, props.branch_id]);

  useEffect(() => {
    const fetchAssistants = async () => {
      try {
        if (availableAssistants.length === 0) {
          setLoading(true);
        } 
        const params = { workspace_id: props.workspace_id };
        const esc = encodeURIComponent;
        const query = Object.keys(params)
          .map((k) => esc(k) + "=" + esc(params[k]))
          .join("&");
        const response = await api.botbuilder.fetchSyncFaqBranchList(query);
        if (response.status) {
          setAvailableAssistants(response.data);
          console.log("Available assistants:", response.data.data);
        } else {
          setAvailableAssistants([]);
        }
      } catch (error) {
        console.error("Error fetching assistants:", error);
        setAvailableAssistants([]);
      } finally {
        setLoading(false); // ✅ End loading
      }
    };
    if (applyModalDetail.modalDisp && props.workspace_id) {
      fetchAssistants();
    }
  }, [applyModalDetail.modalDisp, props.workspace_id]);
  const applyFaqModalBody = () => {
   
 return (
  <div style={{ maxHeight: "fit-content", overflowY: "auto" }}>
    {loading && <div className="ui loading form"></div>}

    {applyError.message && (
      <div
        className={
          applyError.type === "success"
            ? "ui green message"
            : "ui red message"
        }
        style={{ marginBottom: "10px" }}
      >
        {applyError.message}
      </div>
    )}

    {availableAssistants.flatMap((assistant, index) => {
      const flattened = [
        {
          assistant_name: assistant.assistant_name,
          branches: assistant.branches || [],
        },
        ...(assistant.linked_workspaces || []),
      ];

      return flattened.map((item, subIndex) => (
        <div
          key={`${item.assistant_name}_${index}_${subIndex}`}
          style={{ marginBottom: "5px" }}
        >
          <span className="font-bold">{item.assistant_name}</span>
          {item.branches.map((branch) => {
            const isCurrent = branch.branch_id === props.branch_id;
            return (
              <div
                key={branch.branch_id}
                style={{
                  margin: "2px 10px",
                  fontWeight: isCurrent ? "bold" : "normal",
                  padding: "5px",
                  borderRadius: "4px",
                }}
              >
                <Checkbox
                  label={`${
                    branch.position == 1
                      ? branch.branch_name.charAt(0).toUpperCase() +
                        branch.branch_name.slice(1).toLowerCase()
                      : branch.branch_name
                  } ${isCurrent ? "(Current branch)" : ""}`}
                  disabled={isCurrent}
                  onChange={() => {
                    if (!isCurrent) {
                      toggleAssistantSelection(branch.branch_id);
                    }
                  }}
                  checked={
                    !!selectedAssistantsPerBranch[props.branch_id]?.[
                      branch.branch_id
                    ]
                  }
                />
              </div>
            );
          })}
        </div>
      ));
    })}


   {showUnsavedMessage && (
  <div className="ui yellow message" style={{ marginBottom: "10px" }}>
    Multiple assistants selected. Changes will only apply after saving this branch from the preview section or save button.
  </div>
)}

  </div>
);

    
  };
  // const handleApplyToAssistants = async () => {
  //   const selectedIDs = Object.keys(selectedAssistants).filter((id) => selectedAssistants[id]);
  
  //   if (selectedIDs.length === 0) {
  //     setApplyError({ message: "Please select at least one assistant.", type: "error" });
  //     clearApplyErrorAfterDelay();
  //     return;
  //   }
  
  //   const payload = {
  //     assistant_ids: selectedIDs,
  //     context: props.AdditonalFaqContext || "",
  //   };
  
  //   try {
  //     setLoading(true); // Start loading
  
  //     const response = await api.botbuilder.saveFaqSync(payload);
  
  //     if (response.status) {
  //       setApplyError({ message: "FAQs have been successfully applied to the selected assistants or the current branch.", type: "success" });
  //       // Delay before modal close
  //       setLoading(false); 
  //       setTimeout(() => {
  //         setApplyModalDetail({ ...applyModalDetail, modalDisp: false });
  //         setSelectedAssistants({});
  //         setApplyError({ message: "", type: "" });
  //       }, 2000);
  //     } else {
  //       setApplyError({ message: "Failed to apply FAQs.", type: "error" });
  //       setLoading(false); // Stop loading on error
  //       clearApplyErrorAfterDelay();
  //     }
  //   } catch (error) {
  //     console.error("Request failed:", error);
  //     setApplyError({ message: "Something went wrong. Please try again later.", type: "error" });
  //     setLoading(false); // Stop loading on exception
  //     clearApplyErrorAfterDelay();
  //   }
  // };
  

  // helper to auto-clear message after 3 seconds
  const clearApplyErrorAfterDelay = () => {
    setTimeout(() => {
      setApplyError({ message: "", type: "" });
    }, 3000);
  };



  // open question modal on click
  const openAddQuestionModel = () => {
    const modalDetail_temp = { ...modalDetail, modalDisp: true }
    modalDetailSet(modalDetail_temp);
    setInputQuestion("");
    return;
  }
  // close modal on click
  const closeModal = () => {
    const modalDetail_temp = { ...modalDetail, modalDisp: false }
    modalDetailSet(modalDetail_temp);
    setfaqError(false);
    return;
  }

  // hangle question 
  const handleInputQuestion = (event) => {
    setfaqError(false);
    let modalDetail_temp = { ...modalDetail }
    modalDetail_temp.title = "Add an additional question for FAQs";
    modalDetailSet(modalDetail_temp);
    setInputQuestion(event.target.value);
  }

  // handle Additional 
  const handleAdditionalFaqContext = (e) => {
    props.setValue(e.target.value, "AdditonalFaqContext");
  }
  // question modal body return
  const modelBody = (type) => {
    if (type == 'single') {
      return (
        <>
          <input className='form-control' placeholder='Enter Your Question'
            defaultValue={inputQuestion}
            onChange={handleInputQuestion}
            value={inputQuestion}
          />
          {faqError && <small className="text-danger">This field is required.</small>}
        </>
      )
    } else {
      return (
        <>
          <textarea className={`form-group ${faqclasses.conversationText}`}
            value={props.AdditonalFaqContext}
            onChange={(e) => handleAdditionalFaqContext(e)} >
          </textarea>
          {props.workspace_version === 'v2' && (
            <button
              type="button"
              onClick={() => {
                setApplyModalDetail({ ...applyModalDetail, modalDisp: true });
              }}
              className="btn linear-gradient yr-submitbtn btn-sm"
             >
              <span>
                {props.botType === "Voice_Turbo"
                  ? "Apply this FAQs context to other assistants."
                  : "Apply this FAQs context to other context branch."}
              </span>
            </button>
          )}
        </>
      )
    }
  }

  // save question
  const saveQuestios = () => {
    if (inputQuestion.trim() != '') {
      const temp_addquestion = [...addQuestionHTML];
      let newNode = { a: "", q: inputQuestion }
      temp_addquestion.push(newNode);
      addQuestionProcess(temp_addquestion);
      const modalDetail_temp = { ...modalDetail, modalDisp: false }
      modalDetail_temp.title = "Add an additional question for FAQs";
      modalDetailSet(modalDetail_temp);
    } else {
      setfaqError(true);
    }
  }

  //render additional questions
  const renderAdditionalQuestions = () => {
    if (addQuestionHTML) {
      console.log('about', addQuestionHTML);
      return addQuestionHTML.map(
        (el, index) => {
          el = (el && typeof el === 'string') ? JSON.parse(el) : el;
          if (index < 3) {
            return (

              <div className={`${faqclasses.FAQ_section}`}>
                <span>{el.q}</span>
                <textarea className={`form-group ${faqclasses.inputTextare}`}
                  value={el.a}
                  onChange={(event) => setAnswer(event, index)}  >
                </textarea>
              </div>
            )
          } else if (el.a.trim() !== "" && index > 2) {
            return (

              <div className={`${faqclasses.FAQ_section}`}>
                <span>{el.q}</span>
                <textarea className={`form-group ${faqclasses.inputTextare}`}
                  value={el.a}
                  onChange={(event) => setAnswer(event, index)}  >
                </textarea>
              </div>
            )
          }
        }
      );
    } else {
      return (<></>)
    }
  }


  // set answer for
  const setAnswer = (event, index) => {
    let temp_addQuestionHTML = [...addQuestionHTML]
    temp_addQuestionHTML[index] = (temp_addQuestionHTML[index] && typeof temp_addQuestionHTML[index] === 'string') ? JSON.parse(temp_addQuestionHTML[index]) : temp_addQuestionHTML[index];
    temp_addQuestionHTML[index].a = event.target.value;
    props.setValue(temp_addQuestionHTML, "YourFAQA");
  }

const handlePromptSubmit = async () => {
  if (!promptInput.trim()) return;
  setLoading(true);
  try {
    const res = await api.botbuilder.generateFaqs({
      feedback: promptInput,
      current_faqs: props.AdditonalFaqContext
    });
    if (res?.status && res.data?.suggested_faq) {
      setoldAdditionalFaqContext(props.AdditonalFaqContext);
      setnewAdditionalFaqContext(res.data.suggested_faq);
      setFaqDiffModel(true); 
    } else {
     props.setErrorMessage("Oops! Something went wrong while generating FAQs. Please try again.");
    }
  } catch (err) {
   props.setErrorMessage("Oops! Something went wrong while generating FAQs. Please try again.");
  } finally {
    setLoading(false);
  }
};
  return (
    <>
      {FaqDiffModel &&
        <DiffModal
          show={FaqDiffModel}
          oldValue={oldAdditionalFaqContext}
          newValue={newAdditionalFaqContext}
          onCancel={() => setFaqDiffModel(false)}
          onConfirm={handleConfirm}
          title={`Compare Current vs Improved Goal`}
        />
      }

      <div className='row'>
        {props.workspace_version !== 'v2' && (
          <div className='col-md-12'>
            <div className="box-title">FAQs</div>
          </div>
        )}
        <div className={props.workspace_version === "v2" ? "col-md-6" : "col-md-8"}>
          {renderAdditionalQuestions()}
          {props.workspace_version !== 'v2' && (
            <div class="addNewFAQ">
              <a className={`${faqclasses.addLink}`} onClick={() => openAddQuestionModel()} >
                + Add an Additional FAQs
              </a>
            </div>
          )}
          <div className="box-title">
            {props.workspace_version === 'v2' ? 'FAQs Context' : ''}
          </div>
          {modelBody("additonal")}
        </div>
        {props.workspace_version === 'v2' && (
          <div className='col-md-6'
          >
            <div className="box-title">Make a suggestion to improve your FAQs section:</div>
            <textarea
              placeholder="Enter a prompt to generate FAQs"
              className={`${faqclasses.promptText}`}
              value={promptInput}
              onChange={(e) => setPromptInput(e.target.value)}
            />
            {loading && <div className="ui loading form"></div>}

            <button
              type="submit"
              onClick={handlePromptSubmit}
              className="btn linear-gradient yr-submitbtn"
            >
              Submit
            </button>
          </div>
        )}

        <ConfirmDialog
          show={modalDetail.modalDisp}
          toggleModal={saveQuestios}
          closeAction={closeModal}
          title={modalDetail.title}
          message={modelBody('single')}
        />
      </div>
      <Modal
        show={applyModalDetail.modalDisp}
        title={applyModalDetail.title}
        body={applyFaqModalBody()}
        onclose={() => {
          setSelectedAssistantsPerBranch((prev) => {
                const currentBranch = props.branch_id;
                const updated = {};
                // Always keep only the current branch's selection
                if (prev[currentBranch]) {
                  updated[currentBranch] = prev[currentBranch];
                }
                return updated;
              });
          setApplyModalDetail({ ...applyModalDetail, modalDisp: false });
        }}
        footer={<div className="modal-footer">
          <button
            type="button"
            onClick={() => {
              setSelectedAssistantsPerBranch((prev) => {
                const currentBranch = props.branch_id;
                const updated = {};
                // Always keep only the current branch's selection
                if (prev[currentBranch]) {
                  updated[currentBranch] = prev[currentBranch];
                }
                return updated;
              });
              setApplyModalDetail({ ...applyModalDetail, modalDisp: false });
            }}
            className="yr-cancelbtn linear-gradient-cancel btn-sm yr-btn-small"
            data-dismiss="modal"
          >
            <span>Close</span>
          </button>
        </div>
        }
      />
    </>
  )
}